import moment from 'moment-timezone';

export const getForecastDate = (offset = 0) => {
  const date = moment.tz('Asia/Dili').add(offset, 'days').toDate();
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};